export default {
  applicationId: "Zm6SpRVYJPTw7HHoppjko3cVswJO74Nhl3LHxnlj",
  jsId: "RpXz0R9vwWfVTd8NKebfrSQHHNcGXKs8rtEFILep",
  apiUrl: "https://parseapi.back4app.com/",
  anilistApiUrl: "https://graphql.anilist.co"
};
